var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.outtrips.length === 0)?_c('v-list',[_c('v-alert',{attrs:{"type":"info","outlined":""}},[_vm._v(" Cet utilisateur n'a aucun Outtrip ")])],1):_c('OuttripList',{attrs:{"outtrips":_vm.outtrips}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }